<template>
  <div>
    <div v-if="boletoFormatado">
      <div
        class="capa page"
        v-if="dados.dadosEmpresa.boletoComCapaEContracapa == 1 && !isInterno()"
      >
        <img :src="dados.dadosEmpresa.capa" />
      </div>
      <div class="page-interno">
        <div class="cabecalho">
          <div class="vx-row">
            <div
              class="vx-col sm:w-1/4 w-full mb-2"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <img
                :src="dados.dadosEmpresa.logo"
                style="max-height: 120px; max-width: 100%"
              />
            </div>
            <div
              class="vx-col sm:w-3/4 w-full text-center"
              style="
                padding: 15px 10px;
                font-weight: 500;
                justify-content: center;
              "
            ></div>
          </div>
        </div>
        <div class="cabecalho p-1">
          <h6>AO BENEFICIÁRIO(A)</h6>
          <br />
          <p
            class="text-xs"
            v-if="
              dados.dadosCobranca.referente &&
              dados.dadosCobranca.idTipoBoleto != 4
            "
          >
            Referente a: {{ dados.dadosCobranca.referente }}
          </p>
          <br />
          <p class="text-xs mb-1 font-light">Prezado(a) Beneficiário(a)</p>
          <p class="text-xs mb-1 font-light">
            Nosso número da assistência 24h é
            <a href="tel:+5508009445000">0800-944-5000.</a>
          </p>
          <p class="text-xs mb-1 font-light">
            O pagamento deste boleto não quita débitos anteriores. Pague em dia
            e mantenha sua cobertura ativa.
          </p>
          <p
            v-if="dados.dadosCobranca.idTipoBoleto != 4"
            class="text-xs mb-1 font-light"
          >
            Boleto válido até 5 dias corridos após o vencimento. Passado o
            prazo, será necessário uma nova vistoria do veículo.
          </p>
          <p class="text-xs mb-1 font-light">
            Para acesso imediato a segunda via de boletos, aviso de eventos,
            entre outros recursos através de nosso app Bem Protege, disponível
            na app store (IOS) e na play store (ANDROID)
          </p>
          <p class="text-xs mb-1 font-light">
            ATENÇÃO: Mantenha o seu cadastro atualizado junto a Bem Protege,
            como por exemplo: endereço, e-mail e número de telefone. Para isto,
            basta entrar em contato conosco na Central de Atendimento:
            <a href="tel:+553139725000">(31) 3972-5000</a> /
            <a href="tel:+5531999026001">(31) 99902-6001.</a>
          </p>
          <div class="text-xs mb-1 font-light">
            <div v-if="dados.dadosVeiculos && dados.dadosVeiculos.length > 0">
              <ul style="display: flex">
                <li
                  class="d-inline mr-2"
                  v-for="veiculo in dados.dadosVeiculos"
                  :key="veiculo.id_veiculo"
                >
                  {{
                    veiculo.placa
                      ? `Placa: ${veiculo.placa}`
                      : `Chassi: ${veiculo.chassi}`
                  }}
                </li>
              </ul>
            </div>
            <div v-else>
              {{
                dados.dadosCobranca.placa
                  ? `Placa: ${dados.dadosCobranca.placa}`
                  : `Chassi: ${dados.dadosCobranca.chassi}`
              }}
            </div>

            <div v-if="dados.dadosAgregados && dados.dadosAgregados.length > 0">
              <ul class="flex">
                <li
                  class="d-inline mr-2"
                  v-for="agregado in dados.dadosAgregados"
                  :key="agregado.idComplemento"
                >
                  {{
                    agregado.placa
                      ? `Placa: ${agregado.placa}`
                      : `Chassi: ${agregado.chassi}`
                  }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="">
          <table class="table">
            <tr>
              <td class="border-right">
                <img
                  :src="dados.dadosCobranca.banco.logoBanco"
                  class="logo-banco"
                />
              </td>
              <td class="linhaDigitavelOverBoleto border-right" valing="bottom">
                {{ dados.dadosCobranca.banco.codigoBanco }}-0
              </td>
              <td class="linhaDigitavelOverBoleto border-right" valing="bottom">
                <span v-if="showCodeBarAndDigitalLine()">{{
                  dados.dadosCobranca.linhaDigitavel
                }}</span>
              </td>
            </tr>
          </table>
          <table class="table table-bordered table-boleto">
            <tr>
              <td class="linha">
                <span> Nº documento </span>
                <span>
                  {{
                    bancosIncluiIdRemessaBoleto.includes(
                      dados.dadosCobranca.banco.codigoBanco,
                    )
                      ? dados.dadosCobranca.idRemessaBoleto
                      : dados.dadosCobranca.id
                  }}
                </span>
              </td>
              <td class="linha">
                <span> Nosso Número</span>
                <span>
                  {{ formataNossoNumeroCaixa(dados.dadosCobranca.nossoNumero) }}
                </span>
              </td>
              <td class="linha">
                <span>Data Emissão</span>
                <span>{{ formataData(dados.dadosCobranca.dataEmissao) }}</span>
              </td>
              <td class="linha">
                <span>Data Vencimento</span>
                <span>{{
                  formataData(dados.dadosCobranca.dataVencimento)
                }}</span>
              </td>
              <td class="linha">
                <span>Agência/Código do Beneficiário</span>
                <span>
                  {{ dados.dadosCobranca.banco.agencia }}/1220199-{{
                    calculaDigitoVerificador('1220199')
                  }}
                </span>
              </td>
              <td class="linha">
                <span>Carteira</span>
                <span>RG</span>
              </td>
              <td class="linha">
                <span>Valor Documento</span>
                <span>{{ dados.dadosCobranca.valor.toFixed(2) }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="4" class="linha">
                <span> Pagador: </span>
                <span
                  >{{ dados.dadosPagador.nome }} / CPF/CNPJ:
                  {{ dados.dadosPagador.cpfcnpj }}</span
                >
              </td>
              <td colspan="3" class="linha">
                <span>
                  Beneficiário:
                  {{ dados.dadosEmpresa.nome }}
                </span>
                <span>
                  {{
                    `${dados.dadosEmpresa.endereco}, ${dados.dadosEmpresa.numero}, ${dados.dadosEmpresa.complemento}, ${dados.dadosEmpresa.cep}, ${dados.dadosEmpresa.cidade} - ${dados.dadosEmpresa.estado}`
                  }}
                </span>
              </td>
            </tr>
          </table>
          <div class="observacoes">
            <span>
              <p>
                SAC CAIXA: 0800 726 0101 (informações, reclamações, sugestões e
                elogios) Para pessoas com deficiência auditiva ou de fala: 0800
                726 2492 Ouvidoria: 0800 725 7474
              </p>
              <p>caixa.gov.br</p>
            </span>
          </div>
        </div>

        <div class="linhaCorte">RECIBO PAGADOR</div>
        <div class="">
          <table class="table">
            <tr>
              <td class="border-right">
                <img
                  :src="dados.dadosCobranca.banco.logoBanco"
                  class="logo-banco"
                />
              </td>
              <td class="linhaDigitavelOverBoleto border-right" valing="bottom">
                {{ dados.dadosCobranca.banco.codigoBanco }}-0
              </td>
              <td class="linhaDigitavelOverBoleto border-right" valing="bottom">
                <span v-if="showCodeBarAndDigitalLine()">{{
                  dados.dadosCobranca.linhaDigitavel
                }}</span>
              </td>
            </tr>
          </table>
          <table class="table table-bordered table-boleto">
            <tr>
              <td colspan="5" class="linha">
                <span> Local de pagamento </span>
                <span class="texto-upper-negrito">
                  EM TODA A REDE BANCÁRIA E SEUS CORRESPONDENTES ATÉ O VALOR
                  LIMITE
                </span>
              </td>
              <td class="ultimaColuna linha background">
                <span>Vencimento</span>
                <span class="alinha-direita">{{
                  formataData(dados.dadosCobranca.dataVencimento)
                }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="5" class="linha">
                <span>
                  Beneficiário:
                  {{ dados.dadosEmpresa.nome }}
                </span>
                <span>
                  {{
                    `${dados.dadosEmpresa.endereco}, ${dados.dadosEmpresa.numero}, ${dados.dadosEmpresa.complemento}, ${dados.dadosEmpresa.cep}, ${dados.dadosEmpresa.cidade} - ${dados.dadosEmpresa.estado}`
                  }}
                </span>
              </td>
              <td class="ultimaColuna">
                Agência/Código Beneficiário<br />
                <b
                  >{{ dados.dadosCobranca.banco.agencia }}/1220199-{{
                    calculaDigitoVerificador('1220199')
                  }}</b
                >
              </td>
            </tr>
            <tr>
              <td>
                Data do documento <br />
                <b>{{ formataData(dados.dadosCobranca.dataEmissao) }}</b>
              </td>
              <td>
                Nº documento<br /><b>{{
                  bancosIncluiIdRemessaBoleto.includes(
                    dados.dadosCobranca.banco.codigoBanco,
                  )
                    ? dados.dadosCobranca.idRemessaBoleto
                    : dados.dadosCobranca.id
                }}</b>
              </td>
              <td class="linha">Espécie doc.<span>DM</span></td>
              <td>Aceite<br /><b>N</b></td>
              <td>
                Data processamento <br />
                <b>{{ formataData(dados.dadosCobranca.dataEmissao) }}</b>
              </td>
              <td class="ultimaColuna">
                Nosso número<br /><b>{{
                  formataNossoNumeroCaixa(dados.dadosCobranca.nossoNumero)
                }}</b>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="linha">Carteira <b>RG</b></td>
              <td class="linha"><b>Espécie Moeda</b><span>R$</span></td>
              <td>Qtde moeda</td>
              <td class="linha">
                xValor <span>{{ dados.dadosCobranca.valor.toFixed(2) }}</span>
              </td>
              <td class="ultimaColuna linha background">
                <span>(=) Valor documento</span>
                <span class="alinha-direita">{{
                  dados.dadosCobranca.valor.toFixed(2)
                }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="5" rowspan="5">
                Instruções (Texto de responsabilidade do cedente)<br />
                <b>{{ dados.dadosCobranca.instrucao }}</b>
                <p v-if="dados.dadosCobranca.multa !== null">
                  <b
                    >Multa {{ dados.dadosCobranca.multa.toFixed(2) }}%, Juros
                    {{ dados.dadosCobranca.juros.toFixed(2) }}%</b
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td class="ultimaColuna linha">
                <span>(-) Desconto</span>
              </td>
            </tr>
            <tr>
              <td class="ultimaColuna linha">
                <span>(-) Outros</span>
              </td>
            </tr>
            <tr>
              <td class="ultimaColuna linha">
                <span>(+) Mora/Multa/Juros</span>
              </td>
            </tr>
            <tr>
              <td class="ultimaColuna linha">
                <span>(=) Valor Cobrado</span>
                <span class="alinha-direita">{{
                  dados.dadosCobranca.valor.toFixed(2)
                }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                Pagador<br />
                <b
                  >{{ dados.dadosPagador.nome }} /
                  {{ dados.dadosPagador.cpfcnpj }}<br />
                  RUA {{ dados.dadosPagador.endereco }},
                  {{ dados.dadosPagador.numero }}
                  {{ dados.dadosPagador.complemento }},
                  {{ dados.dadosPagador.bairro }}<br />
                  {{ dados.dadosPagador.cep }} -
                  {{ dados.dadosPagador.cidade }} -
                  {{ dados.dadosPagador.estado }}</b
                >
              </td>
              <td class="ultimaColuna">Cód. Baixa</td>
            </tr>
          </table>
          <table class="table" style="font-size: 10px">
            <tr>
              <td width="65%">
                CNPJ Beneficiário: {{ dados.dadosEmpresa.cpfcnpj }}
              </td>
              <td align="right">
                <b>Autenticação mecânica - Ficha de Compensação</b>
              </td>
            </tr>
          </table>
          <div class="barcode text-center" v-if="showCodeBarAndDigitalLine()">
            <barcode
              v-bind:value="dados.dadosCobranca.barCode"
              format="itf"
              :displayValue="false"
              :width="1.75"
              :height="50"
            >
              Show this if the rendering fails.
            </barcode>
          </div>
        </div>
      </div>
      <div
        class="contracapa page"
        v-if="dados.dadosEmpresa.boletoComCapaEContracapa == 1 && !isInterno()"
      >
        <img :src="dados.dadosEmpresa.contracapa" style="max-width: 100%" />
      </div>
    </div>
  </div>
</template>

<script>
import VueBarcode from 'vue-barcode';
import VueQr from 'vue-qr';
import { CopyIcon } from 'vue-feather-icons';

export default {
  name: 'boleto-bemProtege',
  props: ['dadosBoleto'],
  data() {
    return {
      boletoFormatado: false,
      interno: this.$route.query.interno,
      dados: {},
      bancosIncluiIdRemessaBoleto: ['104'],
    };
  },
  methods: {
    isInterno() {
      if (this.interno) {
        return /true/.test(this.interno);
      } else return false;
    },
    formataData(data) {
      const [date, _] = data.split('T');
      const [ano, mes, dia] = date.split('-');
      const _date = `${dia}/${mes}/${ano}`;

      return _date;
    },
    pegarDados() {
      const dados = this._props.dadosBoleto;
      const TIME = 2000;
      const {
        origem,
        dadosToBoleto: {
          dadosCobranca: { banco, linhaDigitavel },
        },
      } = dados;

      this.dados = dados.dadosToBoleto;

      this.boletoFormatado = true;
      this.imprimir(TIME);
    },
    imprimir(TIME = 1000) {
      setTimeout(() => {
        window.print();
      }, TIME);
    },
    showCodeBarAndDigitalLine() {
      const ID_TIPO_BOLETO = 4;
      const isPix = Boolean(this.dadosBoleto.pixQrCode);
      const shouldDisplayBoleto = !(
        isPix && this.dadosBoleto.idTipoBoleto === ID_TIPO_BOLETO
      );

      if (shouldDisplayBoleto) {
        this.dados.dadosCobranca.linhaDigitavel =
          this.formataLinhaDigitavelCaixa(
            this.dados.dadosCobranca.linhaDigitavel,
          );
      }

      return shouldDisplayBoleto;
    },
    formataLinhaDigitavelCaixa(linhaDigitavel) {
      const removeFormatacaoPadrao = linhaDigitavel.replace(/\D/g, '');
      const part1 = removeFormatacaoPadrao.substring(0, 10);
      const part2 = removeFormatacaoPadrao.substring(10, 21);
      const part3 = removeFormatacaoPadrao.substring(21, 32);
      const part4 = removeFormatacaoPadrao.substring(32, 33);
      const part5 = removeFormatacaoPadrao.substring(33);

      return `${part1} ${part2} ${part3} ${part4} ${part5}`;
    },
    formataNossoNumeroCaixa(nossoNumero) {
      const prefixo = '14';
      const zeroEsquerda = nossoNumero.toString().padStart(15, '0');

      const suffixo = `-${this.calculaDigitoVerificador(
        `${prefixo}${zeroEsquerda}`,
      )}`;

      return `${prefixo}${zeroEsquerda}${suffixo}`;
    },
    calculaDigitoVerificador(nossoNumero) {
      const regraDigito = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5, 6, 7, 8, 9, 2];
      const calculoDigito = Array.from(nossoNumero)
        .reverse()
        .map((item, idx) => {
          return regraDigito[idx] * item;
        });

      const somaResult = calculoDigito.reduce((acc, item) => (acc += item));
      const modResult = somaResult % 11;
      const digitoVerificador = 11 - modResult;

      return digitoVerificador > 9 ? 0 : digitoVerificador;
    },
    calcularDigitoVerificadorMod10(campo) {
      campo = campo.replace(/\D/g, '');

      let soma = 0;
      let peso = 2;

      for (let i = campo.length - 1; i >= 0; i--) {
        let num = parseInt(campo[i]) * peso;
        if (num > 9) num -= 9;
        soma += num;
        peso = peso === 2 ? 1 : 2;
      }

      const resto = soma % 10;
      return resto === 0 ? 0 : 10 - resto;
    },
  },
  mounted() {
    this.pegarDados();
  },
  components: { barcode: VueBarcode, VueQr, CopyIcon },
};
</script>
<style lang="scss" scoped>
.table {
  width: 100%;
  font-family: 'Arial';
}
.table-boleto {
  font-size: 10px;
}

.bg-grey {
  background-color: #e7e7e7 !important;
}

.cabecalho {
  font-size: 12px;
  border-bottom: 1px solid #e7e7e7;
  h6 {
    font-size: 14px;
    text-transform: uppercase;
    font-weight: bolder;
  }
}
.ultimoCabecalho {
  border-bottom: 0px !important;
}

.linhaCorte {
  border-bottom: 1px dashed #ccc;
  text-align: right;
  padding: 5px;
  font-size: 10px;
  margin: 10px 0;
}
.veiculo {
  width: 33%;
  float: left;
  margin-bottom: 10px;
}
.barcode div svg {
  width: 90% !important;
}
.linhaDigitavelOverBoleto {
  vertical-align: bottom;
  text-align: center;
  font-size: 18.5px;
  font-family: 'Arial' !important;
  height: 30px;
}
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 0px;
  border-color: grey;
  border: 1px solid grey;

  width: 100%;
  tr td {
    padding: 5px;
    border: 1px solid grey;
    border-bottom: 0px;
  }
  tr:first-child td {
    border-top: 0px;
  }
  tr td:first-child {
    border-left: 0px;
  }
}
.tableinfo td {
  width: 1%;
}

.page img {
  max-width: 100%;
  width: 100%;
  height: auto;
}
.icon {
  width: 16px;
  height: 16px;
  color: #fff;
}
.pointer {
  cursor: pointer;
}
.main-primary {
  background-color: #114880;
}
.main-primary-hover:hover {
  background-color: #145699;
}

.border-right {
  border-right: 1px solid grey;
  width: auto;
}

.logo-banco {
  width: 130px;
  height: 30px;
}

.height-default {
  height: 30px !important;
}
td.linha span,
td.linha b {
  display: block;
}

.texto-upper-negrito {
  text-transform: uppercase;
  font-weight: bolder;
}

.alinha-direita {
  font-size: 12px;
  float: inline-end;
}

.background {
  background-color: #cccccc80;
}

.ultimaColuna {
  width: 180px;
}

.observacoes {
  width: 100%;
  padding: 0px 188px 0px 188px;

  span {
    justify-self: center;
    text-align: center;
    font-size: 10px;
  }
}
</style>
